import React, { useRef, useEffect } from "react";
import cx from "classnames";
import "./Card.scss";
import "./ConfirmCard.scss";
import { Spinner } from "../spinner/Spinner";
import { Button } from "../buttons/Button";
export var CONFIRM_BUTTON_TYPES;
(function (CONFIRM_BUTTON_TYPES) {
    CONFIRM_BUTTON_TYPES[CONFIRM_BUTTON_TYPES["PRIMARY"] = 0] = "PRIMARY";
    CONFIRM_BUTTON_TYPES[CONFIRM_BUTTON_TYPES["NEGATIVE"] = 1] = "NEGATIVE";
})(CONFIRM_BUTTON_TYPES || (CONFIRM_BUTTON_TYPES = {}));
export function ConfirmCard({ children, className, style, onConfirm: confirmCallback, showConfirm, confirmText, confirmButtonText, cancelButtonText, confirmButtonType, confirmButtonSize = "medium", showLoading = false, }) {
    const classes = cx(className, "card", "confirm-card", {
        "confirm-card-active": showConfirm,
        "confirm-card-loading": showLoading,
    });
    const childWrapper = useRef(null);
    useEffect(() => {
        if (!childWrapper || !childWrapper.current) {
            return;
        }
        if (showConfirm) {
            const nodeList = childWrapper.current.querySelectorAll("*");
            for (let i = 0; i < nodeList.length; i++) {
                nodeList[i].setAttribute("tabindex", "-1");
            }
        }
        else {
            const nodeList = childWrapper.current.querySelectorAll("*");
            for (let i = 0; i < nodeList.length; i++) {
                nodeList[i].removeAttribute("tabindex");
            }
        }
    }, [showConfirm, children, childWrapper]);
    return (React.createElement("div", { className: classes, style: style },
        React.createElement("div", { className: "child-wrapper", ref: childWrapper }, children),
        React.createElement("div", { className: "confirm-card-overlay" },
            React.createElement("div", { className: "confirm-card-actions-wrapper" },
                typeof confirmText === "string" ? (React.createElement("h3", null, confirmText)) : (confirmText),
                React.createElement("div", { className: "confirm-card-actions-buttons-wrapper" },
                    React.createElement(Button, { variant: "secondary", className: "confirm-card-action-button", size: confirmButtonSize, onClick: () => confirmCallback(false), label: cancelButtonText }),
                    confirmButtonType === CONFIRM_BUTTON_TYPES.NEGATIVE ? (React.createElement(Button, { variant: "negative", className: "confirm-card-action-button", size: confirmButtonSize, onClick: () => confirmCallback(true), label: confirmButtonText })) : (React.createElement(Button, { variant: "primary", className: "confirm-card-action-button", size: confirmButtonSize, onClick: () => confirmCallback(true), label: confirmButtonText })))),
            React.createElement("div", { className: "confirm-card-loading-wrapper" },
                React.createElement(Spinner, null)))));
}
